import React from 'react'
import _ from 'lodash'

export const formatSubscriptionStatus = (school_subscription) => {
	if (_.isNull(school_subscription)) {
		return (<span className='badge badge-danger'>No Subscription</span>)
	}
	if (school_subscription.isExpired) {
		return (<span className='badge badge-danger'>Expired Subscription</span>)
	}
	// if (_.isEqual(school_subscription.is_approved, 0)) {
	// 	return (<span className='badge badge-warning'>For Verification</span>)
	// }
	if (_.isEqual(school_subscription.is_active, 1)) {
		return (<span className='badge badge-success'>Active</span>)
	}
	if (_.isEqual(school_subscription.is_active, 0)) {
		return (<span className='badge badge-warning'>Deactivated</span>)
	}
	return (<span className='badge badge-danger'>Not Set</span>)
}

export const HandleTaskStatus = (status) => {
	if (_.isEqual(status, 'Pending')) {
		return (<span className='badge badge-primary'>{status}</span>)
	} else if (_.isEqual(status, 'Started')) {
		return (<span className='badge badge-warning'>{status}</span>)
	} else if (_.isEqual(status, 'Completed')) {
		return (<span className='badge badge-success'>{status}</span>)
	} else if (_.isEqual(status, 'Lapsed')) {
		return (<span className='badge badge-danger'>{status}</span>)
	} else if (_.isEqual(status, 'Expired')) {
		return (<span className='badge badge-danger'>{status}</span>)
	} 
}

export const HandleAttendanceType = (attendance_type) => {
	if (_.isEqual(attendance_type, 'Present')) {
		return (<span className='badge badge-success'>{attendance_type}</span>)
	} else if (_.isEqual(attendance_type, 'Absent')) {
		return (<span className='badge badge-danger'>{attendance_type}</span>)
	} else {
		return (<span className='badge badge-warning'>{attendance_type}</span>)
	}
}

export const validateEmail = (emailField) => {
	var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
	if (reg.test(emailField) == false) {
		return false
	}
	return true
}

export const getAge = (date) => {
	const dob = new Date(date)
	const now = new Date()
	const diff = now - dob
	return Math.floor(diff / (1000 * 60 * 60 * 24 * 365))
}

export const getBmi = (bmi) => {
	if(bmi < 18.5) {
		return 'Underweight'
	}
	if(bmi >= 18.5 && bmi < 24.9) {
		return 'Normal'
	}
	if(bmi >= 25 && bmi < 29.9) {
		return 'Overweight'
	}
	if(bmi >= 30) {
		return 'Obese'
	}
}